import { http } from '../../../api/axios';
import { selectionlistConfig } from '../../../config';
import { ProductsResponseOut } from '../../../store/api';
import { Pagination } from '../../../../models/Pagination';
import * as types from '../../../store/constants';

type ParameterTypes = {
    pagination: Pagination;
    filterMap: string;
    listId: string;
    groupId: string | null;
    groupType: string;
};

export const fetchSelectionListProducts = ({ filterMap, pagination, listId, groupId, groupType }: ParameterTypes) => {
    const endpointOpts = {
        pathParams: {
            kind: 'products',
            listId
        }
    };
    const params = { ...pagination, groupType: groupType !== types.GROUPBY_PRODUCTS ? groupType : null, groupId };
    return http
        .post<ProductsResponseOut>(selectionlistConfig().endpointProducts, filterMap, {
            params,
            pathParams: endpointOpts.pathParams
        })
        .then(response => response.data);
};
